import { render, staticRenderFns } from "./EmojiMessage.vue?vue&type=template&id=4e3e3d64&scoped=true"
import script from "./EmojiMessage.vue?vue&type=script&lang=js"
export * from "./EmojiMessage.vue?vue&type=script&lang=js"
import style0 from "./EmojiMessage.vue?vue&type=style&index=0&id=4e3e3d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e3d64",
  null
  
)

export default component.exports